import { FormsModule } from '@angular/forms';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "@components";
import { OrendaComponent } from "./orenda.component";
import { OrendaChemicalHistoryComponent } from "./orenda-chemical-history.component";
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { SwiperModule } from 'swiper/angular';
import { NumberPickerComponent } from '@components/number-picker/number-picker.component';
import { SlickContainerModule, SlickDropDownModule, SlickDatePickerModule, SlickFileDropModule, SlickFileListModule, SlickConfirmDialogModule, SlickButtonSpinnerModule } from '@slick-components';
import { EquipmentTrackingModule } from "@shared-components/equipment-tracking/equipment-tracking.module";

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        FormsModule,
        NgbAccordionModule,
        SwiperModule,
        SlickButtonSpinnerModule,
        SlickContainerModule,
        SlickConfirmDialogModule,
        SlickDropDownModule,
        SlickDatePickerModule,
        SlickFileDropModule,
        SlickFileListModule,
        EquipmentTrackingModule
    ],
    declarations: [
        OrendaComponent,
        OrendaChemicalHistoryComponent,
        NumberPickerComponent
    ],
    exports: [
        OrendaComponent,
        OrendaChemicalHistoryComponent,
        NumberPickerComponent
    ]
})

export class OrendaModule { }
